import { post, get, put, createApiUrl } from './baseApi';

// 사용자 조회
export function getGUser(userId) {
    const request = createApiUrl("/api/v1/admin/user/" + userId);
    return get(request);
}

// 사용자 조회 (게임 잔액 포함)
export function getGUserWithGameBalance(companyCode, userId) {
    const request = createApiUrl("/api/v1/admin/user/" + companyCode + "/" + userId + "/with-game-balance");
    return get(request);
}

export function getGUserList(params) {
    const request = createApiUrl("/api/v1/admin/user/list");
    return post(request, params);
}

export function getGUserListByUserType(userType) {
    const request = createApiUrl("/api/v1/admin/user/userType/" + userType);
    return get(request);
}

export function getGUserListByAccept(companyCode) {
    const request = createApiUrl("/api/v1/admin/user/accept/" + companyCode + "/list");
    return get(request);
}

export function getLoginUserList(params) {
    const request = createApiUrl("/api/v1/admin/user/login/list");
    return post(request, params);
}

// 사용자 수정
export function putGUser(gUser) {
    const request = createApiUrl("/api/v1/admin/user/");
    return put(request, gUser);
}

// 사용자 일괄 생성
export function bulkCreateUsers(params) {
    const request = createApiUrl("/api/v1/admin/user/bulk");
    return post(request, params);
}

// 사용자 검증
export function userCheck(params) {
    const request = createApiUrl("/api/v1/admin/user/exists");
    return post(request, params);
}

export function checkNickname(params) {
    const request = createApiUrl("/api/v1/admin/user/exists/nickname");
    return post(request, params);
}

// 파트너 관련
export function getPartnerTreeList(params) {
    const request = createApiUrl("/api/v1/admin/user/partner/tree");
    return post(request, params);
}

export function getPartnerPossibleUserList(param) {
    const request = createApiUrl("/api/v1/admin/partner/possible/list");
    return post(request, param);
}

export function changeUserPartner(param) {
    const request = createApiUrl("/api/v1/admin/partner/change");
    return post(request, param);
}

// 사용자 롤링 정보
export function putUserRolling(params) {
    const request = createApiUrl("/api/v1/admin/user/rolling");
    return post(request, params);
}

// 사용자 현금/포인트 조회 (관리자용)
export function getUserCashByAdmin(params) {
    const request = createApiUrl("/api/v1/admin/user/cash/admin/list");
    return post(request, params);
}

export function getUserPointByAdmin(params) {
    const request = createApiUrl("/api/v1/admin/user/point/admin/list");
    return post(request, params);
}
